import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminProvider } from "./contexts/AdminContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import EventsCalendar from "./pages/EventsCalendar";
import EventDetail from "./pages/EventDetail";
import JourneySoFar from "./pages/JourneySoFar";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AnimationDemo from "./pages/AnimationDemo";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminJourney from "./pages/admin/AdminJourney";
import AdminDeftFeed from "./pages/admin/AdminDeftFeed";
import AdminFAQs from "./pages/admin/AdminFAQs";
import AdminFounder from "./pages/admin/AdminFounder";
import AdminMetrics from "./pages/admin/AdminMetrics";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminContact from "./pages/admin/AdminContact";

function App() {
  return (
    <AdminProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
            <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
            <Route path="/events" element={<><Navbar /><EventsCalendar /><Footer /></>} />
            <Route path="/events/:id" element={<><Navbar /><EventDetail /><Footer /></>} />
            <Route path="/journey" element={<><Navbar /><JourneySoFar /><Footer /></>} />
            <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />
            <Route path="/privacy" element={<><Navbar /><PrivacyPolicy /><Footer /></>} />
            <Route path="/animation-demo" element={<><Navbar /><AnimationDemo /><Footer /></>} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/events" element={<ProtectedRoute><AdminEvents /></ProtectedRoute>} />
            <Route path="/admin/testimonials" element={<ProtectedRoute><AdminTestimonials /></ProtectedRoute>} />
            <Route path="/admin/journey" element={<ProtectedRoute><AdminJourney /></ProtectedRoute>} />
            <Route path="/admin/deft-feed" element={<ProtectedRoute><AdminDeftFeed /></ProtectedRoute>} />
            <Route path="/admin/faqs" element={<ProtectedRoute><AdminFAQs /></ProtectedRoute>} />
            <Route path="/admin/founder" element={<ProtectedRoute><AdminFounder /></ProtectedRoute>} />
            <Route path="/admin/metrics" element={<ProtectedRoute><AdminMetrics /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/contact" element={<ProtectedRoute><AdminContact /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </div>
    </AdminProvider>
  );
}

export default App;
